/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Interest_Steady_IncomeInputs */

const en_onboarding_v1_interest_steady_income = /** @type {(inputs: Onboarding_V1_Interest_Steady_IncomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Steady income`)
};

const de_onboarding_v1_interest_steady_income = /** @type {(inputs: Onboarding_V1_Interest_Steady_IncomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stetige Erträge`)
};

const pt_br2_onboarding_v1_interest_steady_income = /** @type {(inputs: Onboarding_V1_Interest_Steady_IncomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renda estável`)
};

const tr_onboarding_v1_interest_steady_income = /** @type {(inputs: Onboarding_V1_Interest_Steady_IncomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Düzenli gelir`)
};

const zh_cn2_onboarding_v1_interest_steady_income = /** @type {(inputs: Onboarding_V1_Interest_Steady_IncomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`稳定收益`)
};

const zh_hk2_onboarding_v1_interest_steady_income = /** @type {(inputs: Onboarding_V1_Interest_Steady_IncomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`穩定收益`)
};

const ko_kr2_onboarding_v1_interest_steady_income = /** @type {(inputs: Onboarding_V1_Interest_Steady_IncomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`안정적인 수익`)
};

const ru_ru2_onboarding_v1_interest_steady_income = /** @type {(inputs: Onboarding_V1_Interest_Steady_IncomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стабильный доход`)
};

const es_419_onboarding_v1_interest_steady_income = /** @type {(inputs: Onboarding_V1_Interest_Steady_IncomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingresos estables`)
};

/**
* | output |
* | --- |
* | "Steady income" |
*
* @param {Onboarding_V1_Interest_Steady_IncomeInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_interest_steady_income = /** @type {((inputs?: Onboarding_V1_Interest_Steady_IncomeInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Interest_Steady_IncomeInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_interest_steady_income(inputs)
	if (locale === "de") return de_onboarding_v1_interest_steady_income(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_interest_steady_income(inputs)
	if (locale === "tr") return tr_onboarding_v1_interest_steady_income(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_interest_steady_income(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_interest_steady_income(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_interest_steady_income(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_interest_steady_income(inputs)
	return es_419_onboarding_v1_interest_steady_income(inputs)
});